import type { IRatingMatrixFrameworkOption } from '__generated__';
import { baseApi, optionListTag } from 'store/api';
import {
  API,
  APIRead,
  asPatchBody,
  getAllDynamic,
  normalizeError,
  type PatchBody,
} from 'utils/api-client';
import { buildOptionFilter } from './helpers';

export const ratingMatrixFrameworkOptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOptions: builder.query<IRatingMatrixFrameworkOption[], { subParameterID: number }>({
      async queryFn({ subParameterID }) {
        try {
          const { value } = await getAllDynamic<IRatingMatrixFrameworkOption>(
            (body) => APIRead.api.ratingMatrixFrameworkOptionGetAllDynamicCreate(body),
            {
              filter: buildOptionFilter(subParameterID),
            },
          );

          return { data: value };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      providesTags: (_result, _error, arg) => [optionListTag(arg.subParameterID)],
    }),

    saveOptionsBulk: builder.mutation<
      string,
      { subParameterID: number; items: Partial<IRatingMatrixFrameworkOption>[] }
    >({
      async queryFn({ items }) {
        try {
          const { data } = await API.api.ratingMatrixFrameworkOptionSaveBulkCreate(
            items as IRatingMatrixFrameworkOption[],
          );
          return { data };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      invalidatesTags: (_result, _error, arg) => [optionListTag(arg.subParameterID)],
    }),

    patchOption: builder.mutation<
      string,
      {
        id: number;
        subParameterID: number;
        patch: PatchBody<IRatingMatrixFrameworkOption>;
      }
    >({
      async queryFn({ id, patch }) {
        try {
          const { data } = await API.api.ratingMatrixFrameworkOptionPatchPartialUpdate(
            { id },
            asPatchBody(patch),
          );
          return { data };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      invalidatesTags: (_result, _error, arg) => [optionListTag(arg.subParameterID)],
    }),
  }),
});

export const { useGetOptionsQuery, useSaveOptionsBulkMutation, usePatchOptionMutation } =
  ratingMatrixFrameworkOptionApi;
